import {createActionObject} from '../../redux/utils'
import * as ActionTypes from './actionTypes'
import {LEFT_MIN_WIDTH, RIGHT_MIN_WIDTH} from './constants'
import {saveCPPanelCollapsedCustomersToLocalStorage, saveCPPanelWidthToLocalStorage} from './utils'
import {getCollapsedCustomersSet} from './selectors'
import {arrayToSet} from '../../atUtils'
import {getCustomers} from '../../entities/selectors'

export const setCpPanelMaxWidth = (windowWidth) => (dispatch) => {
    let maxWidth = windowWidth - RIGHT_MIN_WIDTH;
    if (maxWidth < LEFT_MIN_WIDTH)
        maxWidth = LEFT_MIN_WIDTH
    dispatch(createActionObject(ActionTypes.CP_PANEL_MAX_WIDTH_CHANGE, maxWidth))
}

export const setCpPanelWidth = (width) => (dispatch) => {
    dispatch(createActionObject(ActionTypes.CP_PANEL_WIDTH_CHANGE, width))
    saveCPPanelWidthToLocalStorage(width)
}

const changeCollapsedCustomersSet = (newSet) => (dispatch, getState) => {
    const customers = getCustomers(getState())
    const filteredNewSet = removeNotAvailableCustomersFromCollapsedSet(newSet, customers)
    saveCPPanelCollapsedCustomersToLocalStorage(filteredNewSet)
    dispatch(createActionObject(ActionTypes.CP_PANEL_COLLAPSED_CUSTOMERS_SET_CHANGE, newSet))
}

export const addCollapsedCustomers = (collapsedCustomers) => (dispatch, getState) => {
    const currentSet = getCollapsedCustomersSet(getState())
    dispatch(changeCollapsedCustomersSet({
        ...currentSet,
        ...arrayToSet(collapsedCustomers)
    }))
}

export const removeCollapsedCustomers = (customersToRemove) => (dispatch, getState) => {
    const currentSet = getCollapsedCustomersSet(getState())
    const customersToRemoveSet = arrayToSet(customersToRemove)
    dispatch(changeCollapsedCustomersSet(
        arrayToSet(Object.keys(currentSet).filter(cId => !customersToRemoveSet[cId]))
    ))
}

const removeNotAvailableCustomersFromCollapsedSet = (collapsedSet, customers) => {
    return arrayToSet(Object.keys(collapsedSet).filter(cId => !!customers[cId]))
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/actions.js